export default {
  disclaimer: {
    summary:
      'Note que é da sua responsabilidade confirmar que todas as moedas e impostos estão corretos para a jurisdição aplicável.',
    extra:
      'Incluímos esta informação apenas para sua conveniência e não assumimos qualquer responsabilidade pela exatidão da moeda e/ou impostos ou pelo pagamento de tais impostos como parte dos nossos produtos. As informações aqui contidas relacionadas com moeda e impostos são apenas para fins informativos.',
    show_more: 'Mostrar mais',
    show_less: 'Mostrar menos',
  },
  partner_note:
    'Estes são os seus valores predefinidos ao nível do parceiro. Os restaurantes na sua conta herdam estes valores automaticamente, exceto se substituírem uma categoria individualmente.',
  section_title: 'Taxas de imposto para itens do menu',
  new_category_placeholder: 'Nova categoria',
  form: {
    name: {
      label: 'Categoria fiscal',
    },
    default_tax_rate: {
      label: 'Taxa predefinida',
      tooltip: 'Utilizado como alternativa quando uma taxa específica do método de encomenda abaixo estiver vazia.',
    },
    pickup_tax_rate: {
      label: 'Takeaway',
    },
    delivery_tax_rate: {
      label: 'Entrega',
    },
    dine_in_tax_rate: {
      label: 'No restaurante',
    },
    room_service_tax_rate: {
      label: 'Serviço de quarto',
    },
    show_zero_tax_in_summary: {
      label: 'Mostrar 0% de imposto no resumo da encomenda',
    },
  },
  buttons: {
    add_category: 'Adicionar nova categoria fiscal',
    cancel: 'Cancelar',
    save: 'Guardar',
    confirm: 'Eliminar',
    delete: 'Eliminar categoria',
    reset: 'Repor para o herdado',
  },
  delete_confirm: {
    title: 'Eliminar esta categoria fiscal?',
    description: 'Esta ação não pode ser desfeita.',
  },
  scope_labels: {
    region: 'Toda a região',
    partner: 'Todo o parceiro',
    restaurant: 'Todo o restaurante',
  },
  confirm_modal: {
    title: {
      fork: 'Tornar esta categoria própria deste restaurante?',
      owned: 'Aplicar as novas taxas?',
      reset: 'Voltar à categoria herdada?',
    },
    affected_one: '{{count}} produto ou categoria está atualmente associado e será cobrado com as novas taxas.',
    affected_other: '{{count}} produtos e categorias estão atualmente associados e serão cobrados com as novas taxas.',
    affected_settings_one:
      '{{count}} produto ou categoria está atualmente associado e usará as definições atualizadas.',
    affected_settings_other:
      '{{count}} produtos e categorias estão atualmente associados e usarão as definições atualizadas.',
    restaurants_one: 'São {{count}} restaurante.',
    restaurants_other: 'São {{count}} restaurantes.',
    acknowledge:
      'Compreendo que confirmar isto altera a categoria fiscal de todos os produtos atualmente associados a esta categoria',
    impact_error: 'Falha ao verificar quais produtos isto afetaria',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },
  toasts: {
    load_error: 'Não foi possível carregar as categorias fiscais.',
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
    delete_error: 'Não foi possível eliminar esta categoria fiscal.',
    category_deleted: 'Categoria fiscal eliminada',
    category_reset: 'Categoria de imposto reposta para a herdada',
    reset_error: 'Não foi possível repor esta categoria de imposto.',
    impact_error: 'Falha ao verificar quais produtos isto afetaria',
    impact_changed_one: 'O número de produtos afetados mudou para {{count}}. Reveja e confirme novamente.',
    impact_changed_other: 'O número de produtos afetados mudou para {{count}}. Reveja e confirme novamente.',
  },
};
